const config = {
    backendUrl:  process.env.REACT_APP_BACKEND_URL, // default to local if env variable is not set
};

export default config;

// server : process.env.REACT_APP_BACKEND_URL
// server url : https://testing.qtrackr.com:9003/api
// local url : "http://localhost:9000/api"
// https://4581t793-9000.inc1.devtunnels.ms

